import { googleAnalyticsEvent } from 'shared/util/analytics'
import log from 'shared/util/log'

export const CATEGORY = 'Video Player'

// These are documented here:
// https://docs.google.com/spreadsheets/d/18cFvVAH6aihQeOgZz-CG1Qeb-H4LzFCVSagpqjicwWo/edit#gid=1743065185
export type VideoGAActions =
    | 'complete'
    | 'first_quartile'
    | 'midpoint'
    | 'mute'
    | 'pause'
    | 'video_loading'
    | 'player_collapse'
    | 'player_expand'
    | 'start'
    | 'third_quartile'
    | 'unmute'
    | 'video_stalled'
    // custom
    | 'share_sheet_on'
    | 'share_sheet_off'
    | 'facebook'
    | 'instagram'
    | 'reddit'
    | 'pinterest'
    | 'twitter'
    | 'video_shared'
    | 'copy_link'

export const trackEvent = (action: VideoGAActions, label, category = CATEGORY, value?: any) => {
    // to avoid refactoring facebook, reddit, pinterest, twitter use those strings
    log.info(
        `${category} GA Event - action: ${action}, label: ${label}, ${value ? `value: ${JSON.stringify(value)}` : ''}`
    )
    googleAnalyticsEvent({
        category,
        action,
        label,
        value,
    })
}
